import 'cadesplugin'
import { Module, VuexModule, getModule, Action } from 'vuex-module-decorators'
import { Certificates } from '@/types'
import store from '@/store'
declare global {
  interface Window {
      cadesplugin: CADESPluginAsync
  }
}

export interface SIGN {
  cp: CADESPluginAsync
}

@Module({ dynamic: true, store, name: 'SIGN' })
export default class SIGNclass extends VuexModule implements SIGN {
  cp = window.cadesplugin

  @Action({ rawError: true })
  public checkProvider (): Promise<string> {
    return new Promise((resolve, reject) => {
      this.cp.then(async () => {
        const oAbout = await this.cp.CreateObjectAsync('CAdESCOM.About')
        const ProviderName = 'Crypto-Pro GOST R 34.10-2012 Cryptographic Service Provider'
        const ProviderType = '80'
        // const ProviderName = 'Crypto-Pro GOST R 34.10-2001 Cryptographic Service Provider'
        // const ProviderType = '75'
        const oVersion = await oAbout.CSPVersion(ProviderName, parseInt(ProviderType, 10))
        const ver = await oVersion.toString()
        const sCSPName = await oAbout.CSPName(parseInt(ProviderType, 10))
        const prov = sCSPName.toString()
        const provstr = `${prov} - ${ver}`
        resolve(provstr)
      }).catch(e => { reject(e) })
    })
  }

  @Action({ rawError: true })
  public getCertificates (): Promise<Certificates> {
    return new Promise((resolve, reject) => {
      this.cp.then(async () => {
        const store = await this.cp.CreateObjectAsync('CAdESCOM.Store')
        await store.Open()
        const certs = await store.Certificates
        const count = await certs.Count
        const certificates = []
        for (let i = 1; i <= count; i++) {
          const cert = await certs.Item(i)
          const name = await cert.SubjectName
          const fromdate = await cert.ValidFromDate
          const todate = await cert.ValidToDate
          const Valid = await cert.IsValid()
          const isValid = Valid.Result
          const thumbprint = await cert.Thumbprint
          const serial = await cert.SerialNumber
          certificates.push({ isValid: isValid, serial: serial, name: name, fromdate: fromdate, todate: todate, thumbprint: thumbprint })
        }
        await store.Close()
        resolve(certificates)
      }).catch(e => { reject(e) })
    })
  }

  @Action({ rawError: true })
  private findCert (thumbprint: string): Promise<CAPICOM.CertificatesAsync> {
    return new Promise((resolve, reject) => {
      this.cp.then(async () => {
        const store = await this.cp.CreateObjectAsync('CAdESCOM.Store')
        await store.Open()
        const certs = await store.Certificates
        const fcerts = await certs.Find(this.cp.CAPICOM_CERTIFICATE_FIND_SHA1_HASH, thumbprint)
        const count = await fcerts.Count
        if (count === 1) {
          resolve(fcerts)
        } else {
          const e = Error()
          e.name = 'find certificate'
          e.message = 'not found'
          reject(e)
        }
        await store.Close()
      }).catch(e => { reject(e) })
    })
  }

  @Action({ rawError: true })
  public async signXML (prop: { thumbprint: string, data: string }): Promise<string> {
    return new Promise((resolve, reject) => {
      this.cp.then(async () => {
        const fcerts = await this.findCert(prop.thumbprint)
        let sign = ''
        try {
          const cert = await fcerts.Item(1)
          const signer = await this.cp.CreateObjectAsync('CAdESCOM.CPSigner')
          await signer.propset_Certificate(cert)
          const signed = await this.cp.CreateObjectAsync('CAdESCOM.SignedXML')
          await signed.propset_Content(prop.data)
          await signed.propset_SignatureType(this.cp.CADESCOM_XML_SIGNATURE_TYPE_ENVELOPED)
          const signMethod = 'urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-256'
          const digestMethod = 'urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-256'
          await signed.propset_SignatureMethod(signMethod)
          await signed.propset_DigestMethod(digestMethod)
          // await signed.propset_SignatureMethod(this.cp.XmlDsigGost3410Url)
          // await signed.propset_DigestMethod(this.cp.XmlDsigGost3411Url)
          sign = await signed.Sign(signer)
        } catch (err) {
          reject(this.cp.getLastError(err))
        }
        resolve(sign)
      }).catch(e => { reject(e) })
    })
  }

  @Action({ rawError: true })
  public async signCades (prop: { thumbprint: string, docName: string, data: string }): Promise<string> {
    return new Promise((resolve, reject) => {
      this.cp.then(async () => {
        const fcerts = await this.findCert(prop.thumbprint)
        let result = ''
        try {
          const cert = await fcerts.Item(1)
          const docName = await this.cp.CreateObjectAsync('CAdESCOM.CPAttribute')
          await docName.propset_Name(this.cp.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME)
          await docName.propset_Value(prop.docName)
          const signer = await this.cp.CreateObjectAsync('CAdESCOM.CPSigner')
          await signer.propset_Certificate(cert)
          const fsigner = signer as any // в типах не описан параметр AuthenticatedAttributes2
          const attr = await fsigner.AuthenticatedAttributes2
          await attr.Add(docName)
          const signed = await this.cp.CreateObjectAsync('CAdESCOM.CadesSignedData')
          await signed.propset_ContentEncoding(this.cp.CADESCOM_BASE64_TO_BINARY)
          await signed.propset_Content(prop.data)
          result = await signed.SignCades(signer, this.cp.CADESCOM_CADES_BES, true)
        } catch (err) {
          reject(this.cp.getLastError(err))
        }
        resolve(result)
      }).catch(e => { reject(e) })
    })
  }

  @Action({ rawError: true })
  public async checkSignXML (data: string): Promise<Array<string>> {
    return new Promise((resolve, reject) => {
      this.cp.then(async () => {
        const signed = await this.cp.CreateObjectAsync('CAdESCOM.SignedXML')
        let signerName = ''
        let issuerName = ''
        let serial = ''
        let validfrom = {}
        let validto = {}
        let thumb = ''
        try {
          await signed.Verify(data)
          const signers = await signed.Signers
          const signer = await signers.Item(1)
          const cert = await signer.Certificate
          signerName = await cert.SubjectName
          issuerName = await cert.IssuerName
          serial = await cert.SerialNumber
          validfrom = await cert.ValidFromDate
          validto = await cert.ValidToDate
          thumb = await cert.Thumbprint
        } catch (err) {
          reject(this.cp.getLastError(err))
        }
        resolve([`Субъект: ${signerName}`, `Издатель: ${issuerName}`, `Серийный номер: ${serial}`, `Срок действия: ${validfrom} - ${validto}`, `Отпечаток: ${thumb}`])
      }).catch(e => { reject(e) })
    })
  }

  @Action({ rawError: true })
  public async checkSignPDF (prop: { data: string, sign: string }): Promise<Array<string>> {
    return new Promise((resolve, reject) => {
      this.cp.then(async () => {
        const signed = await this.cp.CreateObjectAsync('CAdESCOM.CadesSignedData')
        let signerName = ''
        let issuerName = ''
        let serial = ''
        let validfrom = {}
        let validto = {}
        let thumb = ''
        let docName = ''
        let signTime = ''
        await signed.propset_ContentEncoding(this.cp.CADESCOM_BASE64_TO_BINARY)
        await signed.propset_Content(prop.data)
        try {
          await signed.VerifyCades(prop.sign, this.cp.CADESCOM_CADES_BES, true)
          const fsigned = signed as any // в типах не описан параметр Signers
          const signers = await fsigned.Signers
          const signer = await signers.Item(1)
          const attrs = await signer.AuthenticatedAttributes2
          const attrcount = await attrs.Count
          for (let i = 1; i <= attrcount; i++) {
            const attr = await attrs.Item(i)
            const attrname = await attr.Name
            if (attrname === this.cp.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME) {
              docName = await attr.Value
            }
          }
          const time = await signer.SigningTime
          signTime = new Date(time).toString()
          const certs = await signed.Certificates
          const cert = await certs.Item(1)
          signerName = await cert.SubjectName
          issuerName = await cert.IssuerName
          serial = await cert.SerialNumber
          validfrom = await cert.ValidFromDate
          validto = await cert.ValidToDate
          thumb = await cert.Thumbprint
        } catch (err) {
          reject(this.cp.getLastError(err))
        }
        resolve([`Файл: ${docName}`, `Дата подписания: ${signTime}`, `Субъект: ${signerName}`, `Издатель: ${issuerName}`, `Серийный номер: ${serial}`, `Срок действия: ${validfrom} - ${validto}`, `Отпечаток: ${thumb}`])
      }).catch(e => { reject(e) })
    })
  }
}

export const SIGNModule = getModule(SIGNclass)
